<template>
  <div class="room" ref="room">
    <vb-card variant="horizontal"
      :card="{
        image: room_image,
        title: room_name,
        text: room.description,
        text_clamped: true,
      }"
      @click_image="$bvModal.show(modal_id)"
    >
      <span
        v-if="room.description"
        class="room__readmore"
        v-b-modal="modal_id"
      >leggi tutto</span>

      <vb-modal
        :vb_options="{
          id: modal_id,
          body_class: 'room__modal',
          centered: true,
          hide_footer: true,
          size: 'lg'
        }"
      >
        <img
          v-if="room_image"
          class="room__modal-image"
          :src="room_image"
          :alt="room_name"
        />
        <h5 class="room__modal-title" v-html="room_name"></h5>
        <p class="room__modal-description" v-html="room.description"></p>
      </vb-modal>

      <div class="room__footer" v-if="rates.length">
        <div class="room__rates">
          <vb-select
            v-model="selected_rate_idx"
            :vb_options="{
              options: rate_options,
              value: selected_rate_idx,
            }"

          />
          <span class="room__price" v-if="current_rate && current_rate.pricing">
            {{ markup(current_rate.pricing.total).display_price }}&euro;
          </span>
        </div>

        <vb-button
          :vb_options="{
            text: is_selected ? 'Selezionata' : 'Scegli',
            variant: is_selected ? 'outline-info' : 'dark',
            size: 'md',
            disabled: is_selected,
          }"
          @click="select_room"
        />
      </div>
    </vb-card>
  </div>
</template>

<script> 
export default {
  name: 'room',

  inheritAttrs: false,

  inject: ['on_room_selected', 'room_selection'],

  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
    room_index: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      selected_rate_idx: 0,
      confirmed_rate: null,
    }
  },
 


  computed: {
    modal_id() {
      return 'room-modal-' + this._uid
    },

    room_name() {
      if (!this.room.name) return ''
      return this.room.name.charAt(0).toUpperCase() + this.room.name.slice(1).toLowerCase()
    },

    room_image() {
      const images = this.room.images
      if (images && images.length && images[0].url) return images[0].url
      return ''
    },

    rates() {
      return this.room.rates || []
    },

    rate_options() {
      return this.rates.map((rate, index) => {
        return {
          value: index,
          text: rate.description
            ? rate.description.charAt(0).toUpperCase() + rate.description.slice(1).toLowerCase()
            : '',
        }
      })
    },

    current_rate() {
      return this.rates[this.selected_rate_idx] || null
    },

    is_selected() {
      return this.room_selection.index === this.room_index
        && this.confirmed_rate !== null
        && this.confirmed_rate === this.selected_rate_idx
    },
  },

  methods: {
    select_room() {
      this.confirmed_rate = this.selected_rate_idx
      this.on_room_selected({
        room_index: this.room_index,
        rate: this.current_rate,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .room {

    &__readmore {
      position: absolute;
      margin-top: -.925rem;
      right: 1.9rem;
      background: $white;
      padding-left: $grid-gutter-width/3;
      color: $info;
      text-decoration: underline;
      cursor: pointer;
      font-size: $font-size-sm;
    }

    &__modal {
      &-image {
        width: 100%;
        border-radius: $border-radius-lg;
        margin-bottom: $grid-gutter-width / 3;
      }

      &-title {
        margin-bottom: $grid-gutter-width / 6;
      }

      &-description {
        font-size: $font-size-sm;
        margin-bottom: 0;
      }
    }

    &__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: $grid-gutter-width / 3;
      padding-top: $grid-gutter-width / 3;
      border-top: 1px solid $gray-200;
    }

    &__rates {
      display: flex;
      align-items: center;
      flex-basis: 60%;
    }

    &__price {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-lg;
      white-space: nowrap;
      margin-left: $grid-gutter-width / 2
    }

    .vb-select {
      font-size: $font-size-sm;
    }

    .vb-btn {
      display: block;
      width: 100%;
      margin-top: $grid-gutter-width/3;
      border: 1px solid transparent !important;

      @include media-breakpoint-up(xl) {
        margin-top: 0;
        flex-basis: 30%;
      }
    }
  }
</style>
